
import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "How does Edaptica's adaptive learning work?",
    answer: "Edaptica uses AI to analyze your learning patterns, strengths, and areas for improvement. Our system then creates personalized learning paths, adjusting question difficulty and focus areas in real-time as you learn and progress."
  },
  {
    question: "Which exams does Edaptica support?",
    answer: "Edaptica supports a wide range of competitive exams, including JEE (Main & Advanced), NEET, GATE, UPSC, government exams, and professional certifications. Our platform is constantly expanding to include more exam categories."
  },
  {
    question: "Can I access Edaptica on mobile devices?",
    answer: "Yes! Edaptica is fully responsive and works seamlessly on desktops, laptops, tablets, and mobile phones, allowing you to learn anytime, anywhere."
  },
  {
    question: "How is Edaptica different from other learning platforms?",
    answer: "Unlike standard platforms, Edaptica adapts to your unique learning style and needs. Our AI-powered system identifies your knowledge gaps, provides real-time feedback, and continuously adjusts your learning path for maximum effectiveness."
  },
  {
    question: "Do I need to install any software to use Edaptica?",
    answer: "No installation required. Edaptica is a web-based platform that works directly in your browser. Simply create an account and start learning immediately."
  },
  {
    question: "Are there any live sessions or instructor support?",
    answer: "Edaptica combines AI-powered learning with community support. While our primary focus is on adaptive self-paced learning, we offer AI tutoring for instant help and a community feature to connect with peers and educators."
  }
];

export function FAQ() {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <div className="inline-block bg-orange-50 rounded-full px-4 py-1 mb-4">
            <span className="text-orange-600 font-medium text-sm">Common Questions</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find answers to common questions about Edaptica's adaptive learning platform.
          </p>
        </motion.div>
        
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
              >
                <AccordionItem value={`item-${index}`}>
                  <AccordionTrigger className="text-lg font-medium hover:text-primary">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
